import { call, put } from 'redux-saga/effects';
import api from '../Api/leaderboard';
import {  readLeaderboardSuccessAction} from '../Actions/LeaderboardActions';

export function* leaderboardReadSaga(action) {
   
    const leaderboard = yield call(api.leaderboard.read);


    yield put(readLeaderboardSuccessAction(leaderboard));
}



// WEBPACK FOOTER //
// ./src/Sagas/leaderboardSagas.js